import { BookOpenIcon, ChevronDownIcon } from "lucide-react";
import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from "../ui/collapsible";

/** Useful context on demand, without repeating it on every skill. */
export function SkillsGuide() {
  return (
    <Collapsible className="mt-5 rounded-xl bg-muted/50">
      <CollapsibleTrigger className="group flex w-full items-center gap-2.5 rounded-xl px-4 py-3 text-left text-sm outline-none focus-visible:ring-2 focus-visible:ring-ring">
        <BookOpenIcon aria-hidden className="size-4 text-muted-foreground" />
        <span className="flex-1 font-medium">How skills work</span>
        <ChevronDownIcon
          aria-hidden
          className="size-4 text-muted-foreground transition-transform group-data-panel-open:rotate-180 motion-reduce:transition-none"
        />
      </CollapsibleTrigger>
      <CollapsiblePanel className="motion-reduce:transition-none">
        <dl className="grid gap-5 px-4 pb-4 pt-1 text-sm md:grid-cols-3 md:gap-8">
          <div>
            <dt className="font-medium text-foreground">Start with your task</dt>
            <dd className="mt-1.5 leading-6 text-muted-foreground">
              Describe what you need in chat, or name a skill. Skills give Amoreg a method to
              follow, such as preparing a board pack or reviewing a policy.
            </dd>
          </div>
          <div>
            <dt className="font-medium text-foreground">Connect accounts separately</dt>
            <dd className="mt-1.5 leading-6 text-muted-foreground">
              Plugins give Amoreg access to accounts like Gmail or Drive. Skills guide the work;
              they do not connect accounts or grant extra permissions.
            </dd>
          </div>
          <div>
            <dt className="font-medium text-foreground">Save your team's method</dt>
            <dd className="mt-1.5 leading-6 text-muted-foreground">
              Ask in chat to save a repeatable process as a skill. Administrators can create and
              update organisation skills for the team to reuse.
            </dd>
          </div>
        </dl>
      </CollapsiblePanel>
    </Collapsible>
  );
}
